import { ComponentType, FC, ReactNode } from "react";

import { IconLabel } from "@/components/_atoms/icon-label";

interface ListHeaderTitleProps {
  icon: ComponentType<{ className?: string }>;
  label: ReactNode;
}

export const ListHeaderTitle: FC<ListHeaderTitleProps> = ({ icon, label }) => {
  return <IconLabel icon={icon} label={label} />;
};
